export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevron-left.311cf6a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};